module.exports = __webpack_public_path__ + "static/the-sleepeasy-solution-ddb1af6f18b48701041b34990311df97.jpg";